var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "BjDivider",
        {
          scopedSlots: _vm._u([
            {
              key: "right",
              fn: function () {
                return [
                  _vm.pageType === "inform"
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.showLog },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "BusinessPurchaseReturnComDetail.operationLog"
                              )
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c("el-button", { on: { click: _vm.handleClose } }, [
                    _vm._v(_vm._s(_vm.$t("backText"))),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(
            " " +
              _vm._s(_vm.$t("BusinessPurchaseReturnComDetail.purchaseText")) +
              _vm._s(_vm.text) +
              _vm._s(_vm.$t("BusinessPurchaseReturnComDetail.statusText")) +
              " "
          ),
        ]
      ),
      _c("div", { staticClass: "bj-row mt20" }, [
        _c("div", { staticClass: "bj-col bj-col-24" }, [
          _c("div", { staticClass: "bj-form-title" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t("BusinessPurchaseReturnComDetail.statusMeaning")
                ) +
                ": "
            ),
            _c("span", { staticClass: "red" }, [
              _vm._v(_vm._s(_vm.data.statusMeaning)),
            ]),
          ]),
          _c("div", { staticClass: "flex-center" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.pageType === "inform",
                    expression: "pageType === 'inform'",
                  },
                ],
                staticClass: "text-center numBox",
              },
              [
                _c("p", [
                  _vm._v(
                    _vm._s(_vm.$t("BusinessPurchaseReturnComDetail.planQty"))
                  ),
                ]),
                _c("span", [_vm._v(_vm._s(_vm.data.planQty || 0))]),
              ]
            ),
            _c("div", { staticClass: "text-center numBox" }, [
              _c("p", [
                _vm._v(
                  _vm._s(_vm.$t("BusinessPurchaseReturnComDetail.alreadyQty"))
                ),
              ]),
              _c("span", [_vm._v(_vm._s(_vm.data.alreadyQty || 0))]),
            ]),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.pageType === "inform",
                    expression: "pageType === 'inform'",
                  },
                ],
                staticClass: "text-center numBox",
              },
              [
                _c("p", [
                  _vm._v(
                    _vm._s(_vm.$t("BusinessPurchaseReturnComDetail.waitQty"))
                  ),
                ]),
                _c("span", [_vm._v(_vm._s(_vm.data.waitQty || 0))]),
              ]
            ),
          ]),
        ]),
      ]),
      _c("BjDivider", [
        _vm._v(
          " " +
            _vm._s(_vm.$t("BusinessPurchaseReturnComDetail.purchaseText")) +
            _vm._s(_vm.text) +
            _vm._s(_vm.$t("BusinessPurchaseReturnComDetail.informationText")) +
            " "
        ),
      ]),
      _c("div", { staticClass: "bj-row mt20" }, [
        _c("div", { staticClass: "bj-col" }, [
          _c("div", { staticClass: "bj-form-item" }, [
            _c("div", { staticClass: "bj-form-item-label" }, [
              _vm._v(
                _vm._s(_vm.$t("BusinessPurchaseReturnComDetail.stockoutCode"))
              ),
            ]),
            _c("div", { staticClass: "bj-form-item-value" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.pageType === "inform"
                      ? _vm.data.code
                      : _vm.data.stockoutCode
                  ) +
                  " "
              ),
            ]),
          ]),
          _c("div", { staticClass: "bj-form-item" }, [
            _c("div", { staticClass: "bj-form-item-label" }, [
              _vm._v(
                _vm._s(_vm.$t("BusinessPurchaseReturnComDetail.resultCode"))
              ),
            ]),
            _c("div", { staticClass: "bj-form-item-value" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.pageType === "inform"
                      ? _vm.data.stockoutResultCodeList.join()
                      : _vm.data.code
                  ) +
                  " "
              ),
            ]),
          ]),
          _c("div", { staticClass: "bj-form-item" }, [
            _c("div", { staticClass: "bj-form-item-label" }, [
              _vm._v(
                _vm._s(_vm.$t("BusinessPurchaseReturnComDetail.typeMeaning"))
              ),
            ]),
            _c("div", { staticClass: "bj-form-item-value" }, [
              _vm._v(_vm._s(_vm.data.typeMeaning)),
            ]),
          ]),
          _c("div", { staticClass: "bj-form-item" }, [
            _c("div", { staticClass: "bj-form-item-label" }, [
              _vm._v(
                _vm._s(_vm.$t("BusinessPurchaseReturnComDetail.supplierName"))
              ),
            ]),
            _c("div", { staticClass: "bj-form-item-value" }, [
              _vm._v(_vm._s(_vm.data.supplierName)),
            ]),
          ]),
          _c("div", { staticClass: "bj-form-item" }, [
            _c("div", { staticClass: "bj-form-item-label" }, [
              _vm._v(
                _vm._s(_vm.$t("BusinessPurchaseReturnComDetail.warehouseName"))
              ),
            ]),
            _c("div", { staticClass: "bj-form-item-value" }, [
              _vm._v(_vm._s(_vm.data.warehouseName)),
            ]),
          ]),
          _c("div", { staticClass: "bj-form-item" }, [
            _c("div", { staticClass: "bj-form-item-label" }, [
              _vm._v(
                _vm._s(_vm.$t("BusinessPurchaseReturnComDetail.purchaseCode"))
              ),
            ]),
            _c("div", { staticClass: "bj-form-item-value" }, [
              _vm._v(_vm._s(_vm.data.purchaseCode)),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "bj-col" }, [
          _c("div", { staticClass: "bj-form-item" }, [
            _c("div", { staticClass: "bj-form-item-label" }, [
              _vm._v(_vm._s(_vm.$t("table.creatorText"))),
            ]),
            _c("div", { staticClass: "bj-form-item-value" }, [
              _vm._v(_vm._s(_vm.data.createdName)),
            ]),
          ]),
          _c("div", { staticClass: "bj-form-item" }, [
            _c("div", { staticClass: "bj-form-item-label" }, [
              _vm._v(_vm._s(_vm.$t("table.createTimeText"))),
            ]),
            _c("div", { staticClass: "bj-form-item-value" }, [
              _vm._v(_vm._s(_vm.data.creationDate)),
            ]),
          ]),
          _vm.pageType === "inform"
            ? _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-form-item-label" }, [
                  _vm._v(
                    _vm._s(_vm.$t("BusinessPurchaseReturnComDetail.auditDate"))
                  ),
                ]),
                _c("div", { staticClass: "bj-form-item-value" }, [
                  _vm._v(_vm._s(_vm.data.auditDate)),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "bj-form-item" }, [
            _c("div", { staticClass: "bj-form-item-label" }, [
              _vm._v(
                _vm._s(_vm.$t("BusinessPurchaseReturnComDetail.stockoutDate"))
              ),
            ]),
            _c("div", { staticClass: "bj-form-item-value" }, [
              _vm._v(_vm._s(_vm.data.stockoutDate)),
            ]),
          ]),
          _c("div", { staticClass: "bj-form-item" }, [
            _c("div", { staticClass: "bj-form-item-label" }, [
              _vm._v(_vm._s(_vm.$t("table.remarkText"))),
            ]),
            _c("div", { staticClass: "bj-form-item-value" }, [
              _vm._v(_vm._s(_vm.data.remark)),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "bj-col" }, [
          _c("div", { staticClass: "bj-form-item" }, [
            _c("div", { staticClass: "bj-form-item-label" }, [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "BusinessPurchaseReturnComDetail.logisticsBusinessName"
                  )
                )
              ),
            ]),
            _c("div", { staticClass: "bj-form-item-value" }, [
              _vm._v(_vm._s(_vm.data.logisticsBusinessName)),
            ]),
          ]),
          _c("div", { staticClass: "bj-form-item" }, [
            _c("div", { staticClass: "bj-form-item-label" }, [
              _vm._v(
                _vm._s(_vm.$t("BusinessPurchaseReturnComDetail.logisticsNo"))
              ),
            ]),
            _c("div", { staticClass: "bj-form-item-value" }, [
              _vm._v(_vm._s(_vm.data.logisticsNo)),
            ]),
          ]),
          _c("div", { staticClass: "bj-form-item" }, [
            _c("div", { staticClass: "bj-form-item-label" }, [
              _vm._v(
                _vm._s(_vm.$t("BusinessPurchaseReturnComDetail.recipientName"))
              ),
            ]),
            _c("div", { staticClass: "bj-form-item-value" }, [
              _vm._v(_vm._s(_vm.data.recipientName)),
            ]),
          ]),
          _c("div", { staticClass: "bj-form-item" }, [
            _c("div", { staticClass: "bj-form-item-label" }, [
              _vm._v(
                _vm._s(_vm.$t("BusinessPurchaseReturnComDetail.recipientPhone"))
              ),
            ]),
            _c("div", { staticClass: "bj-form-item-value" }, [
              _vm._v(_vm._s(_vm.data.recipientPhone)),
            ]),
          ]),
          _c("div", { staticClass: "bj-form-item" }, [
            _c("div", { staticClass: "bj-form-item-label" }, [
              _vm._v(
                _vm._s(
                  _vm.$t("BusinessPurchaseReturnComDetail.recipientAddress")
                )
              ),
            ]),
            _c("div", { staticClass: "bj-form-item-value" }, [
              _vm._v(
                " " +
                  _vm._s(
                    (_vm.data.recipientProvince || "") +
                      (_vm.data.recipientCity || "") +
                      (_vm.data.recipientDistrict || "") +
                      (_vm.data.recipientAddress || "")
                  ) +
                  " "
              ),
            ]),
          ]),
        ]),
      ]),
      _c("BjDivider", [
        _vm._v(
          " " +
            _vm._s(_vm.$t("BusinessPurchaseReturnComDetail.table.title")) +
            " "
        ),
      ]),
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.data.goodsList,
            border: "",
            script: "",
            "max-height": "600",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("table.countText"),
              type: "index",
              width: "65",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("BusinessPurchaseReturnComDetail.table.spuPic"),
              prop: "spuPic",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("BjViewUrl", {
                      attrs: {
                        url: (JSON.parse(row.spuPic) || [])[0],
                        height: "60px",
                        preview: "",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("BusinessPurchaseReturnComDetail.table.skuCode"),
              prop: "skuCode",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("BusinessPurchaseReturnComDetail.table.skuName"),
              prop: "skuName",
              align: "center",
            },
          }),
          _vm.pageType === "inform"
            ? _c("el-table-column", {
                attrs: {
                  label: _vm.$t(
                    "BusinessPurchaseReturnComDetail.table.planQty"
                  ),
                  prop: "planQty",
                  align: "center",
                  width: "150",
                },
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("BusinessPurchaseReturnComDetail.table.alreadyQty"),
              prop: "alreadyQty",
              align: "center",
            },
          }),
          _vm.pageType === "inform"
            ? _c("el-table-column", {
                attrs: {
                  label: _vm.$t(
                    "BusinessPurchaseReturnComDetail.table.waitQty"
                  ),
                  prop: "waitQty",
                  align: "center",
                  width: "150",
                },
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t(
                "BusinessPurchaseReturnComDetail.table.taxUnitPrice"
              ),
              width: "110",
              prop: "taxUnitPrice",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("BusinessPurchaseReturnComDetail.table.taxRate"),
              prop: "taxRate",
              width: "100",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [_vm._v(" " + _vm._s(row.taxRate) + "% ")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("BusinessPurchaseReturnComDetail.table.taxPrice"),
              prop: "taxPrice",
              width: "120",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t(
                "BusinessPurchaseReturnComDetail.table.supplierSpuCode"
              ),
              width: "130",
              prop: "supplierSpuCode",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t(
                "BusinessPurchaseReturnComDetail.table.supplierSkuCode"
              ),
              width: "110",
              prop: "supplierSkuCode",
              align: "center",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }